import {
    AppBar, Backdrop, Dialog, DialogContent, IconButton, Paper, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Toolbar, Typography,
} from "@material-ui/core";
import moment from "moment";
import React, { useState } from "react";
import { PuffLoader } from "react-spinners";
import { useStyles } from "./ClientPlacementHistoryCss";
import { usePost } from "../../../utils/apiHelper";
import CloseIcon from "@material-ui/icons/Close";
import { ARMLogo } from "../../../constants/Constant";
import HistoryIcon from "@mui/icons-material/History";
import { useGlobalState } from "../../../store/GlobalStore";
import { Transition } from "../../GlobalStyles/DialogBoxTransition";
import { IGetClientPlacementHistory } from "../../../models/accesscontrol/IClientPlacementContext";
import { IClientTemplate } from "../../../models/Admin/ClientPlacements/IClientTemplate";

const ClientPlacementHistory: React.FC<{ userRow: IClientTemplate }> = (props) => {
    const { userRow } = props;
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const [clientPlacementHistory, setClientPlacementHistory] = useState<IGetClientPlacementHistory[]>([]);
    const [ProgressBar, setShowProgressBar] = useState(false);
    const { state } = useGlobalState();

    const handleClickOpen = () => {
        setOpen(true);
        getProspectHistory();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getProspectHistory = () => {
        setShowProgressBar(true);
        (async () => {
            let request = {
                "clientCode": userRow?.clT_CODE,
            };
            await usePost<IGetClientPlacementHistory[]>("History/GetClientPlacementHistory", request).then((GetAllUsersHistory) => {
                setClientPlacementHistory(GetAllUsersHistory?.data);
            }).finally(() => {
                setShowProgressBar(false);
            });
        })();
    };

    function EnhancedTableHead(props) {
        const { classes, order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        const headCells = [
            { id: "ClientCode", disablePadding: false, label: "CLIENT CODE", sortable: false, },
            { id: "ClientName", disablePadding: false, label: "CLIENT NAME", sortable: false },
            { id: "OldTemplateName", disablePadding: false, label: "OLD TEMPLATE", sortable: false },
            { id: "NewTemplateName", disablePadding: false, label: "NEW TEMPLATE", sortable: false },
            { id: "OldSLS2ColumnValue", disablePadding: false, label: "OLD SLS2", sortable: false },
            { id: "NewSLS2ColumnValue", disablePadding: false, label: "NEW SLS2", sortable: false },
            { id: "actionTakenBy", disablePadding: false, label: "ACTION TAKEN BY", sortable: false },
            { id: "actionTakenDate", disablePadding: false, label: "ACTION DATE", sortable: false },
        ];

        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false} className={classes.TableCellStyle} >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label || headCell.sortable}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    return (
        <div>
            <IconButton style={{ padding: "5px" }} onClick={handleClickOpen}>
                <HistoryIcon style={{ color: "#B30987" }} />
            </IconButton>

            <Dialog fullScreen className={classes.dialog} open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar className={classes.toolbarStyle}>
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" >
                            <img alt="ARM_Solutions" className={classes.menuButton1} src={ARMLogo} />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            <b> TEMPLATE CHANGE HISTORY ({userRow?.clT_CODE} - {userRow?.clT_NAME_1})</b>
                        </Typography>
                        <IconButton edge="end" color="inherit" onClick={() => setOpen(false)} aria-label="close" style={{ padding: '5px' }}>
                            <CloseIcon className={classes.closeIconButton} />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Backdrop className={classes.backdrop} open={ProgressBar}>
                    <PuffLoader size={80} color={"white"} speedMultiplier={1} />
                </Backdrop>
                <DialogContent>
                    {/* <TextField
                        value={searchParameters}
                        variant="outlined"
                        type="text"
                        placeholder="Search..."
                        className={classes.searchBox}
                        onChange={(e) => { handleChangeValues(e); }}
                        onKeyPress={(event) => {
                            if (event.key === "Enter" && searchParameters != "") {
                                handleSearchEmail();
                                setShowSearchIcon(false);
                            } else if (event.key === "Enter" && searchParameters === "") {
                                handleSearchEmailClear();
                                setShowSearchIcon(true);
                            }
                        }}
                        inputProps={{ maxlength: 255 }}
                        InputProps={{
                            classes: {
                                root: classes.outlinedInputs,
                                notchedOutline: classes.notchedOutline,
                            },
                            endAdornment: (
                                <InputAdornment position="end">
                                    {showSearchIcon === true ? (
                                        <IconButton onClick={(e) => { handleSearchEmail(); setShowSearchIcon(false); }} style={{ marginLeft: 15 }}>
                                            <SearchIcon />
                                        </IconButton>
                                    ) : (
                                        <IconButton onClick={(e) => { setSearchParameters(""); clearSearchValues(); }}>
                                            <CloseIcon />
                                        </IconButton>
                                    )}
                                </InputAdornment>
                            ),
                        }}
                    /> */}
                    <TableContainer component={Paper} className={`${classes.tablebody1} ${"scrollbox"} ${"on-scrollbar"}`} >
                        <Table size="small" aria-label="customized table" stickyHeader>
                            <EnhancedTableHead classes={classes} />
                            {clientPlacementHistory?.map((row) => (
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.clientCode}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {userRow?.clT_NAME_1}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.oldTemplateName}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.newTemplateName}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.oldSLS2ColumnValue}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.newSLS2ColumnValue}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.modifiedUserName}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" className={classes.tableCellFontSize}>
                                                {moment(row?.modifiedDate)?.format(state?.GlobalUtils?.settingValue)}{" "}
                                                {moment(row?.modifiedDate).format("HH:mm:ss")}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ))}
                        </Table>
                        {!clientPlacementHistory.length && !ProgressBar ?
                            <Typography variant="h6" align='center' gutterBottom className={classes.ErrorMessageStyle1}>
                                No history to display..
                            </Typography> : null}
                    </TableContainer>
                </DialogContent>
            </Dialog>
        </div >
    )
}

export default ClientPlacementHistory